import React from 'react';
import { GridToolbarColumnsButton } from '@mui/x-data-grid';
import { styled } from '@mui/material';

const StyledColumnsButton = styled(GridToolbarColumnsButton)(() => ({
    fontSize: '0',
    '& .MuiButton-startIcon': {
        marginRight: '0',
    },
    '& .MuiSvgIcon-root:nth-of-type(1)': {
        fontSize: '2.4rem',
    },
    border: 'none',
    minWidth: 0,
}));

const ToolbarColumnsButton = ({ ...props }) => {
    return <StyledColumnsButton sx={{ color: 'secondary.extraLight' }} {...props} />;
};

export default ToolbarColumnsButton;
